



















import { Component, Vue } from 'vue-property-decorator';

import PriorityTeacherPage from './teacher-data/index.vue';
import PriorityClazzPage from './clazz-data/index.vue';
import PriorityTeacherCourseGroupCampusReportPage from './teacher-course-group-campus-report/index.vue';
import PriorityClazzCourseGroupCampusReportPage from './clazz-course-group-campus-report/index.vue';

import { Load } from '@/domains/system';

@Component({
  name: 'RecordTabsPage',
  components: {
    PriorityTeacherPage,
    PriorityClazzPage,
    PriorityTeacherCourseGroupCampusReportPage,
    PriorityClazzCourseGroupCampusReportPage,
  },
})
export default class RecordTabsPage extends Vue {
  /** bus */
  private bus: Vue = new Vue();

  /** 加载 */
  private load: Load = new Load();

  /** active */
  private active: string = 'teacherCourseGroupCampusReport';

  private clickTab() {
    switch (this.active) {
      case 'teacherList':
        this.$nextTick(() => { this.bus.$emit('priority-teacher-search'); });
        break;
      case 'clazzList':
        this.$nextTick(() => { this.bus.$emit('priority-clazz-search'); });
        break;
      case 'teacherCourseGroupCampusReport':
        this.$nextTick(() => { this.bus.$emit('priority-teacher-course-group-campus-report-search'); });
        break;
      case 'clazzCourseGroupCampusReport':
        this.$nextTick(() => { this.bus.$emit('priority-clazz-course-group-campus-report-search'); });
        break;
      default:
        return;
    }
  }

  private mounted() {
    this.$nextTick(() => { this.bus.$emit('priority-teacher-course-group-campus-report-search'); });
  }
}
